<div class="dash_base">
  <div class="container">
    <div class="row mt-5">
      <div class="col-lg-12 Analysis-head">
        <div class="head-left-cell">
          <mat-icon routerLink="/saved">arrow_back</mat-icon>
          <h4>Equity Analysis</h4>
        </div>
        <div class="save-equity">
          <button class="ml-1" type="submit" cdkFocusInitial mat-flat-button color="primary" (click)="saveEquity()">
            {{ button }}
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <app-property-overview
          [address]="propertyData"
          [currentValue]="currentValue"
          [propmixValue]="propmixValue"
          [loanBalance]="loanBalance"
          [netEquity]="netEquity"
          [appreciateRatio]="appreciateRatio"
          [purchaseValue]="purchaseValue"
          [source]="'equityAnalysis'"
        >
        </app-property-overview>
      </div>
    </div>
  </div>
  <app-financing
    [appreciateRatio]="appreciateRatio"
    [currentValue]="this.currentValue"
    [propmixValue]="this.propmixValue"
    [loanBalance]="loanBalance"
    [netEquity]="netEquity"
    [purchaseValue]="purchaseValue"
  >
  </app-financing>
</div>

<!-- 
<div class="dash_base">

































  <div class="row">
    <div class="col-lg-12">
      <app-property-overview
        [address]="propertyData"
        [currentValue]="currentValue"
        [propmixValue]="propmixValue"
        [loanBalance]="loanBalance"
        [netEquity]="netEquity"
        [appreciateRatio]="appreciateRatio"
        [purchaseValue]="purchaseValue"
      >
      </app-property-overview>
    </div>
  </div>

  <app-financing
    [appreciateRatio]="appreciateRatio"
    [currentValue]="this.currentValue"
    [propmixValue]="this.propmixValue"
    [loanBalance]="loanBalance"
    [netEquity]="netEquity"
    [purchaseValue]="purchaseValue"
  >
  </app-financing>
</div> -->
